import { NgModule } from '@angular/core'
import { RouterModule, Routes } from '@angular/router'
import { PublicMainComponent } from './components/public/public-layout.component'
import { noGoogleTagsGuard } from './services/cookie-consent.service'

export const routes: Routes = [
  {
    path: '',
    component: PublicMainComponent,
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./components/public/components/home/home.component').then(
            (m) => m.HomeComponent
          ),
        title: 'seo.titles.home',
      },
      { path: 'home', redirectTo: '/', pathMatch: 'full' },
      {
        path: 'about',
        loadComponent: () =>
          import('./components/public/components/about/about.component').then(
            (m) => m.AboutComponent
          ),
        title: 'About',
      },
      {
        path: 'services',
        loadComponent: () =>
          import('./components/public/components/services/services.component').then(
            (m) => m.ServicesComponent
          ),
        title: 'seo.titles.services',
      },
      {
        path: 'work-safety',
        loadComponent: () =>
          import('./components/public/components/work-safety/work-safety.component').then(
            (m) => m.WorkSafetyComponent
          ),
        title: 'Work Safety',
      },
      {
        path: 'questions',
        loadComponent: () =>
          import('./components/public/components/questions/questions.component').then(
            (m) => m.QuestionsComponent
          ),
        title: 'Frequently asked questions',
      },
      {
        path: 'contact',
        loadComponent: () =>
          import('./components/public/components/contact/contact.component').then(
            (m) => m.ContactComponent
          ),
        title: 'Contact',
      },
      {
        path: 'thank-you',
        loadComponent: () =>
          import('./components/public/components/thank-you/thank-you.component').then(
            (m) => m.ThankYouComponent
          ),
        title: 'Thank you',
      },
      {
        path: 'news',
        loadComponent: () =>
          import('./components/public/components/news/news.component').then(
            (m) => m.NewsComponent
          ),
        title: 'News',
      },
      {
        path: 'news/:id',
        loadComponent: () =>
          import('./components/public/components/news/news-detail/news-detail.component').then(
            (m) => m.NewsDetailComponent
          ),
        title: 'News Article',
      },
      {
        path: 'user-experiences',
        loadComponent: () =>
          import('./components/public/components/user-experiences/user-experiences.component').then(
            (m) => m.UserExperienceComponent
          ),
        title: 'User experience',
      },
      {
        path: 'login',
        loadChildren: () =>
          import('./components/public/components/login/login.routes').then(
            (m) => m.LOGIN_ROUTES
          ),
      },
      {
        path: 'signup',
        canActivate: [noGoogleTagsGuard],
        loadComponent: () =>
          import('./components/public/components/signup/signup.component').then(
            (m) => m.SignupComponent
          ),
        title: 'Sign Up',
      },
      {
        path: 'privacy',
        loadComponent: () =>
          import('./components/public/components/privacy/privacy.component').then(
            (m) => m.PrivacyComponent
          ),
        title: 'Privacy Policy',
      },
      {
        path: 'terms',
        loadComponent: () =>
          import('./components/public/components/terms/terms.component').then(
            (m) => m.TermsComponent
          ),
        title: 'Terms of Service',
      },
      {
        path: 'unsubscribe',
        loadComponent: () =>
          import('./components/public/components/unsubscribe/unsubscribe.component').then(
            (m) => m.UnsubscribeComponent
          ),
        title: 'Unsubscribe',
      },
      {
        path: 'partnerships',
        redirectTo: '/about',
        pathMatch: 'full',
      },
      {
        path: 'userexp',
        redirectTo: '/user-experiences',
        pathMatch: 'full',
      },
      {
        path: 'error',
        loadComponent: () =>
          import('./components/shared/error-page/error-page.component').then(
            (m) => m.ErrorPageComponent
          ),
        title: 'Error',
        data: {
          code: 'Oops',
          titleKey: 'errors.generic.title',
          messageKey: 'errors.generic.message',
          actionKey: 'errors.actions.home',
          actionLink: '/',
        },
      },
      {
        path: '404',
        loadComponent: () =>
          import('./components/shared/error-page/error-page.component').then(
            (m) => m.ErrorPageComponent
          ),
        title: 'Page not found',
        data: {
          code: '404',
          titleKey: 'errors.notFound.title',
          messageKey: 'errors.notFound.message',
          actionKey: 'errors.actions.home',
          actionLink: '/',
        },
      },
    ],
  },
  {
    path: 'dashboard',
    loadChildren: () =>
      import('./components/private/dashboard.routes').then(
        (m) => m.DASHBOARD_ROUTES
      ),
  },
  { path: '**', redirectTo: '/404' },
]

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
